import { processFileUploads, getMutationVariables, getMutationVariablesWithFiles, getFormMutation } from './formieMutations.js';

/**
 * Enhanced form submission handler that processes file uploads before form submission
 *
 * @param {Object} form - The form configuration object
 * @param {HTMLElement} formElement - The form DOM element
 * @param {Object} gqlClient - The GraphQL client instance
 * @param {Function} onSuccess - Success callback function
 * @param {Function} onError - Error callback function
 * @returns {Promise<void>}
 */
export const submitFormWithFileUploads = async (form, formElement, gqlClient, onSuccess, onError) => {
    try {
        // Step 1: Process file uploads first
        // console.log('Processing file uploads...');
        // const uploadedFiles = await processFileUploads(form, formElement, gqlClient);
        // console.log('Uploaded files:', uploadedFiles);

        // Step 2: Get form mutation variables with uploaded file IDs
        // const formData = getMutationVariablesWithFiles(form, formElement, uploadedFiles);
        const formData = await getMutationVariables(form, formElement);
        const formMutation = getFormMutation(form);

        // Step 3: Submit the form with file IDs
        console.log('Submitting form with file IDs...');
        const mutationData = await gqlClient.request(formMutation, formData);

        const response = mutationData[`save_${form.handle}_Submission`];
        onSuccess(response);
    } catch (error) {
        console.error('Form submission error:', error);
        onError(error);
    }
};

/**
 * Example usage in a Vue component:
 *
 * ```javascript
 * import { submitFormWithFileUploads } from '@/utils/formieFileUpload.js'
 *
 * const handleFormSubmit = async () => {
 *     const form = data.value.form // Your form configuration
 *     const formElement = formElement.value // Your form DOM element
 *     const gqlClient = gqlClient // Your GraphQL client
 *
 *     await submitFormWithFileUploads(
 *         form,
 *         formElement,
 *         gqlClient,
 *         (response) => {
 *             // Success handler
 *             console.log('Form submitted successfully:', response)
 *             loading.value = false
 *         },
 *         (error) => {
 *             // Error handler
 *             console.error('Form submission failed:', error)
 *             loading.value = false
 *             alertState.value = 'error'
 *         }
 *     )
 * }
 * ```
 */

/**
 * For specific file upload fields like "cv" and "coverLetter":
 *
 * The system will automatically detect these fields if they have:
 * - inputTypeName: "FileUploadInput" (single file)
 * - inputTypeName: "[FileUploadInput]" (multiple files)
 *
 * The uploaded file IDs will be passed to the form submission mutation
 * as the field values instead of the actual file data.
 *
 * IMPORTANT: This implementation is compatible with Craft CMS's FileUploadInput type,
 * which only accepts 'filename' and 'fileData' fields. Other fields like 'size' and
 * 'mimeType' are automatically filtered out to prevent GraphQL validation errors.
 */
